import { createContext, useContext, useState } from 'react';

const PageTitleContext = createContext();

export const PageTitleProvider = ({ children }) => {
  const [pagetitle, setPageTitle] = useState(''); // Default title

  return (
    <PageTitleContext.Provider value={{ pagetitle, setPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
};

export const usePageTitle = () => useContext(PageTitleContext);